/**
 * The feature areas the public website shows: one card each on the home page and the pricing pages,
 * one section each on /features (`#<key>` anchors). Texts are `pages.features.areas.<key>.*`.
 *
 * Every line must be true today — checked against the code on 2026-10-25. `optional` areas are tools
 * a studio may turn on; the site says so, because "do I have to take payments?" stops people.
 */
export const FeatureAreaKey = {
  PAGE: 'page',
  BOOKINGS: 'bookings',
  CLIENTS: 'clients',
  PAYMENTS: 'payments',
  PASSES: 'passes',
  STUDIOS: 'studios'
}

export const FEATURE_AREAS = [
  {
    key: FeatureAreaKey.PAGE,
    icon: 'mdi-web',
    optional: false,
    items: ['own-page', 'layouts', 'class-link']
  },
  {
    key: FeatureAreaKey.BOOKINGS,
    icon: 'mdi-calendar-check-outline',
    optional: false,
    items: ['no-account', 'group-and-private', 'limits', 'close', 'cancel', 'reminder', 'confirmation', 'cancel-class', 'child', 'selected-clients']
  },
  {
    key: FeatureAreaKey.CLIENTS,
    icon: 'mdi-card-account-details-outline',
    optional: false,
    items: ['register', 'participants', 'first-timers', 'source', 'monthly']
  },
  {
    key: FeatureAreaKey.PAYMENTS,
    icon: 'mdi-credit-card-outline',
    optional: true,
    items: ['providers', 'per-class', 'paid-first', 'cash', 'fee']
  },
  {
    key: FeatureAreaKey.PASSES,
    icon: 'mdi-ticket-confirmation-outline',
    optional: true,
    items: ['passes', 'buy-online', 'first-visit', 'invoice']
  },
  {
    key: FeatureAreaKey.STUDIOS,
    icon: 'mdi-account-group-outline',
    optional: false,
    items: ['one-schedule', 'trainer-access']
  }
]
